module.exports = __webpack_public_path__ + "static/media/file.af1f9d02.svg";